import { AppDispatch } from '../store';
import { handleError } from '../slices/errors.slice';
import { changeStep } from '../slices/step.slice';
import { checkIntegrationService } from '../../services/CheckIntegrationService';
import { ALREADY_PROCESSED_ERROR, processUpdateErrors } from './fetch-integration-data';

export const startPosIdentSession = () => {
	return async (dispatch: AppDispatch) => {
		try {
			const response = await checkIntegrationService.createPosIdentSession();

			if (response.data?.errors) {
				dispatch(processUpdateErrors(response.data.errors));
				return;
			}

			dispatch(changeStep('POS_IDENT_REDIRECT_STEP'));
		} catch (error: any) {
			const message = error?.response?.data?.error;
			if (message === ALREADY_PROCESSED_ERROR) {
				dispatch(processUpdateErrors([message]));
				return;
			}
			dispatch(handleError(error));
		}
	};
};
